import { BodyRegular, FlexAlignCenter } from 'components/Elements';
import { formatDateToString } from 'lib/time-helpers';
import styled from 'styled-components';
import { sizes, theme, breakpoints } from 'theme';
import strings from '../../../strings/strings.json';
import { IconSize } from 'assets/icons/icon-sizes';
import ValidateIcon from 'assets/icons/indicators/ValidateIcon';

export default function CourseCompleteDate({ completedDate }: { completedDate: Date }) {
    return (
        <CompletedContainer>
            <ValidateIcon size={IconSize.MEDIUM} />
            <DateText $bold>{strings.learnerCourseCard.completed}</DateText>
            <DateText>{formatDateToString(completedDate)}</DateText>
        </CompletedContainer>
    );
}

const DateText = styled(BodyRegular)`
    display: flex;
    gap: ${sizes.spacingXs};
    white-space: nowrap;
`;

const CompletedContainer = styled(FlexAlignCenter)`
    gap: ${sizes.spacingXs};
    width: 100%;
    justify-content: end;
    background-color: ${theme.notificationSuccessBackground};
    border-radius: ${sizes.spacingMd};
    width: fit-content;
    padding: ${sizes.spacingSm} ${sizes.spacingMd};

    @media (max-width: ${breakpoints.md}) {
        justify-content: unset;
    }
`;
